export default function Testimonials() {
  const testimonials = [
    {
      id: 1,
      name: 'Sarah Chen',
      location: 'UK, 2024',
      text: 'Greenify made my dream of studying at a UK university come true. Their guidance through the application process was invaluable, and they were always available to answer my questions.',
      avatar: 'https://public.readdy.ai/ai/img_res/e6896f5fe6da533f592667b3761fbb7b.jpg',
      type: 'card'
    },
    {
      id: 2,
      name: 'Michael Okonkwo',
      location: 'Canada, 2023',
      text: 'The team at Greenify was incredibly supportive throughout my entire journey. From university selection to visa approval, they handled everything professionally and efficiently.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20young%20African%20male%20student%20smiling%20warmly%2C%20simple%20clean%20background%2C%20natural%20lighting%2C%20confident%20expression%2C%20university%20graduate%2C%20professional%20photography&width=200&height=200&seq=avatar-002&orientation=squarish',
      type: 'card'
    },
    {
      id: 3,
      name: 'Priya Sharma',
      location: 'Australia, 2024',
      text: 'I cannot thank Greenify enough for their personalized approach. They understood my goals and helped me find the perfect program in Australia.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20young%20Indian%20female%20student%20smiling%20brightly%2C%20simple%20clean%20background%2C%20natural%20lighting%2C%20happy%20expression%2C%20university%20graduate%2C%20professional%20photography&width=200&height=200&seq=avatar-003&orientation=squarish',
      type: 'image'
    },
    {
      id: 4,
      name: 'James Rodriguez',
      location: 'Ireland, 2023',
      text: 'Exceptional service from start to finish. The pre-departure orientation was particularly helpful in preparing me for life in Ireland.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20young%20Hispanic%20male%20student%20smiling%20confidently%2C%20simple%20clean%20background%2C%20natural%20lighting%2C%20friendly%20expression%2C%20university%20graduate%2C%20professional%20photography&width=200&height=200&seq=avatar-004&orientation=squarish',
      type: 'small'
    },
    {
      id: 5,
      name: 'Aisha Mohammed',
      location: 'USA, 2024',
      text: 'Greenify turned what seemed like an overwhelming process into a smooth and manageable journey. Highly recommended!',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20young%20Middle%20Eastern%20female%20student%20smiling%20warmly%2C%20simple%20clean%20background%2C%20natural%20lighting%2C%20confident%20expression%2C%20university%20graduate%2C%20professional%20photography&width=200&height=200&seq=avatar-005&orientation=squarish',
      type: 'small'
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-3 h-3 bg-slate-900 rotate-45"></div>
            <p className="text-sm uppercase tracking-wider text-slate-900 font-medium">
              Student Success Stories
            </p>
          </div>
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900">Hear From Our Students</h3>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-4 sm:mb-6">
          {testimonials.slice(0, 3).map((testimonial) => (
            <div key={testimonial.id}>
              {testimonial.type === 'image' ? (
                <div className="relative h-96 rounded-3xl overflow-hidden group">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-transparent to-transparent"></div>
                  <div className="absolute bottom-6 left-6 text-white">
                    <p className="text-2xl font-bold mb-1">{testimonial.name}</p>
                    <p className="text-sm text-gray-300">{testimonial.location}</p>
                  </div>
                </div>
              ) : (
                <div className="bg-slate-100 rounded-3xl p-8 h-full hover:shadow-xl transition-shadow">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <div>
                      <p className="font-bold text-slate-900 text-lg">{testimonial.name}</p>
                      <p className="text-sm text-gray-600">{testimonial.location}</p>
                    </div>
                  </div>
                  <div className="w-12 h-12 flex items-center justify-center mb-4">
                    <i className="ri-double-quotes-l text-4xl text-emerald-500"></i>
                  </div>
                  <p className="text-slate-700 leading-relaxed text-base">{testimonial.text}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
          {testimonials.slice(3).map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-slate-100 rounded-3xl p-6 hover:shadow-xl transition-shadow"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-3xl text-emerald-500"></i>
              </div>
              <p className="text-slate-700 leading-relaxed text-sm mb-6">{testimonial.text}</p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div>
                  <p className="font-bold text-slate-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
